import { activityHistoryFiltersSlice } from "../../slice";

export const { setCustomFilterValue } = activityHistoryFiltersSlice.actions;
